import { render, staticRenderFns } from "./prenota-un-viaggio.vue?vue&type=template&id=7128d371&scoped=true"
import script from "./prenota-un-viaggio.vue?vue&type=script&lang=js"
export * from "./prenota-un-viaggio.vue?vue&type=script&lang=js"
import style0 from "./prenota-un-viaggio.vue?vue&type=style&index=0&id=7128d371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7128d371",
  null
  
)

export default component.exports